import React from "react";
import { Navigate } from "react-router-dom";
import { AuthUser } from "../types";

// Client-side convenience only, same spirit as RequireRole - the backend
// already returns [] safely for a non-manager (see requests_api.py's
// my_approvals comment), so this isn't a security boundary. It exists purely
// so a direct /my-approvals navigation matches the nav link being hidden,
// rather than "Manager" becoming a role check (it deliberately isn't one -
// see db/models.py's User docstring).
export default function RequireManager({
  user,
  children
}: {
  user: AuthUser;
  children: React.ReactNode;
}) {
  if (!user.isManager) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
